export const Routes = {
  Main: {
    StackName: 'Main',
    Drawer: 'Drawer',
    Home: 'Home',
    Stays: 'Stays',
    Play: 'Play',
    Offers: 'Offers',
    Signin: 'Signin',
    Profile: 'My Account',
    TransferCredits: 'Transfer Credits',
    LinkAccount: 'Link Account',
    Terms: 'Terms',
  },
  Offers: {
    StackName: 'Offers',
    Home: 'Offers',
    Filters: 'Filters',
    Destinations: 'Destinations',
    Properties: 'Properties',
    Dates: 'Dates',
    OfferTypes: 'OfferTypes',
  },
  Modal: {
    StackName: 'Modal',
    ErrorModal: 'Modal.ErrorModal',
    ConfirmationModal: 'Modal.ConfirmationModal',
    LoadingModal: 'Modal.LoadingModal',
  },
  Experiences: 'Experiences',
};

export const APP_BASE_URL = 'rewards';

export interface LinkData {
  title: string;
  analyticsHref: string;
  url: string;
  newRewardsScreen?: string;
}

/**
 * This is a map where the key is the title of a link in the Navigation elements,
 * and the value is the internal page to navigate to.
 * When running in non-legacy mode, we should use React Navigation and go to the specified route.
 * When running in legacy mode, we should just redirect to what is in the URL
 */
export const SupportedLinksMap = new Map<string, string>();
SupportedLinksMap.set('Offers', Routes.Main.Offers);
SupportedLinksMap.set('My Offers', Routes.Main.Offers);
SupportedLinksMap.set('Home', Routes.Main.Home);
SupportedLinksMap.set('Account', Routes.Main.Profile);
SupportedLinksMap.set('Stays', Routes.Main.Stays);
